import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  UntypedFormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { AvInvestment } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';
import { PledgeProductRead } from '../../definition/interface/Pledge';
import FormGroupArray from '../../services/FormGroupArray';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }) {
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        avProgammedPaymentType: [
          entity?.parameters?.avProgammedPaymentType || 'MONTHLY',
        ],
        lifeInsuranceMinInitialPayment: [
          entity?.parameters?.lifeInsuranceMinInitialPayment || 0,
        ],
        lifeInsuranceMinOnLifePayment: [
          entity?.parameters?.lifeInsuranceMinOnLifePayment || 0,
        ],
        lifeInsuranceProgrammedPaymentMensuel: [
          entity?.parameters?.lifeInsuranceProgrammedPaymentMensuel || 0,
        ],
        avInvestmentType: [
          entity && entity?.parameters?.avInvestmentType
            ? entity?.parameters?.avInvestmentType
            : 'MONTHLY',
          [
            this.prFormService.RefreshEveryValidators([
              'avInitialPayment',
              'avMonthlyPayment',
            ]),
            Validators.required,
          ],
        ],
        avMonthlyPayment: [
          entity && entity?.parameters?.avMonthlyPayment
            ? entity?.parameters?.avMonthlyPayment
            : null,
          [Validators.required],
        ],
        avInitialPayment: [
          entity && entity?.parameters?.avInitialPayment
            ? entity?.parameters?.avInitialPayment
            : null,
          [Validators.required],
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: AvInvestment[], option) {
    const form = FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });

    return form;
  }
  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  extract() {
    const formValue = _.cloneDeep(this.form?.value?.products);
    formValue?.forEach(item => {
      if (
        item.parameters.avInvestmentType === 'MONTHLY' &&
        item?.parameters?.lifeInsuranceMinInitialPayment > 0
      )
        item.parameters.avInitialPayment =
          item.parameters.avInitialPayment ||
          item?.parameters?.lifeInsuranceMinInitialPayment ||
          0;
    });
    return formValue;
  }
  // one value is required

  public oneValueRequired(): ValidatorFn {
    return (formGroup: UntypedFormGroup) => {
      const avMonthlyPayment = formGroup.get('avMonthlyPayment').value;
      const avInitialPayment = formGroup.get('avInitialPayment').value;
      const lifeInsuranceMinInitialPayment =
        formGroup.get('lifeInsuranceMinInitialPayment')?.value || 0;
      const lifeInsuranceProgrammedPaymentMensuel =
        formGroup.get('lifeInsuranceProgrammedPaymentMensuel')?.value || 0;

      if (
        !avMonthlyPayment &&
        avMonthlyPayment < (lifeInsuranceProgrammedPaymentMensuel || 150) &&
        !avInitialPayment &&
        avInitialPayment < lifeInsuranceMinInitialPayment
      ) {
        return { invalid: true };
      }

      return null;
    };
  }
}
